import type { KontentinoPage } from '../types';
import { PLATFORM_NAMES } from '../constants';

interface PageCardProps {
  page: KontentinoPage;
}

export function PageCard({ page }: PageCardProps) {
  return (
    <div className="flex items-center gap-3 flex-1 min-w-0">
      {page.avatar && (
        <img
          src={page.avatar}
          alt={page.name}
          className="w-10 h-10 rounded-full flex-shrink-0"
        />
      )}
      <div className="flex-1 min-w-0">
        <div className="font-medium text-foreground truncate">{page.name}</div>
        <div className="text-sm text-muted-foreground">
          {PLATFORM_NAMES[page.platform]}
          {page.username && ` • ${page.username}`}
        </div>
      </div>
    </div>
  );
}
